import { Spacer as SpacerBlock } from '@introcloud/blocks';
import { createElement } from 'react';
export function Spacer({ dragging, options }) {
    return createElement(SpacerBlock, Object.assign(Object.assign({}, options), { style: { backgroundColor: dragging ? 'rgba(0,0,0,.1)' : 'transparent' } }));
}
